<ng-container *ngIf="presentation == 'dialog'; else content">
  <modal-popup [flexible]="true"  [isOpen]="true" (onClose)="close()"
    [title]="claimToolLabel | translate"
    [afterTitle]="save" [isLoading]="isLoading">

      <ng-container *ngTemplateOutlet="content"></ng-container>

  </modal-popup>
</ng-container>
  <ng-template #content>
    <div class="single-phrase-details-container">
      
      <div class="l-align-spaceBetween">
        <h3>{{ "translate.general.workingPhrase" | translate }}</h3>
      </div>
      <div class="single-phrase-details-content single-phrase-element-margin" style="margin-top: 0.5rem;">
        <div style="display: flex; flex-direction: row;">
          <formatted-phrase [phraseWords]="claimToolElement.phraseWords"></formatted-phrase>
            <div>
              <i [ngClass]="{ 'disabled': isLoading }"  class="fas fa-file icon-edit" (click)="showDetailsDialog()"
                tooltip="{{ 'translate.cat.phraseDetailsTitle' | translate }}"></i>
            </div>
            <p *ngIf="genaiPhraseMerged === true" style="font-style: italic; text-align: right; margin-right: 0.4em; margin-bottom: 0.2em; color: #9d9fa2">
              <ai-icon></ai-icon>

            </p>

        </div>
      </div>
      <!--<spinner *ngIf="loadingContentTypes" class="l-ta-center"></spinner>-->
      <div style="display: flex; flex-direction: row;" class="cat-phrase-type single-phrase-element-margin">
      <div *ngIf="claimToolElement.contentType">
        <a (click)="overlay.toggle($event);" [ngClass]="{ 'disabled': enforceOperationDependencies && mergeOrSplitExecuted }"
        >{{ claimToolElement.contentTypeDesc }}
        </a>
          <p-popover #overlay [dismissable]="true" appendTo="body" baseZIndex="999999">
              <ul class="menu-list">
                <li *ngFor="let item of contentTypeOptions" [class.disabled]="enforceOperationDependencies && mergeOrSplitExecuted" (click)="changeType(item)"
                [ngClass]="{ 'selected': item.id === claimToolElement.contentType }">
                  {{ item.label }}
                </li>
              </ul>
          </p-popover>
      </div>
      <i  (click)="opTypes.toggle($event)" [ngClass]="{ 'disabled': mergeOrSplitExecuted }" class="fas fa-edit icon-edit"></i>
      <p *ngIf="genaiPhraseMerged === true" style="font-style: italic; text-align: right; margin-right: 0.4em; margin-bottom: 0.2em; color: #9d9fa2">
        <ai-icon></ai-icon>
      </p>
      <p-popover #opTypes appendTo="body" baseZIndex="999999">
          <ng-container *ngTemplateOutlet="typesTree"></ng-container>
      </p-popover>
      </div>
      <!-- showing references old implementation
      
      <div *ngIf="claimToolElement.references" class="reference">
        <p class="title">{{ "translate.rev.reference" | translate }}:</p>
        <div *ngFor="let ref of claimToolElement.references" class="ref-container">
          <p *ngIf="ref.phraseDispWords.length == 0" class="text">
            {{ ref.refPhraseText }}
          </p>
          <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" class="text"
            [phraseWords]="ref.phraseDispWords"></formatted-phrase>
        </div>
      </div>
      -->
      <!--
      <p *ngIf="claimToolElement.references != undefined && claimToolElement.references.length > 0" class="single-phrase-details-ref-title single-phrase-element-margin">

        {{ "translate.rev.reference" | translate }}:   
    
      </p>
      
        <ng-container *ngFor="let ref of claimToolElement.references">
          <div class="single-phrase-ref-container single-phrase-element-margin">
            <phrase-ref class="ref" [ref]="ref"[allowEdit]="false"
            [showEdit]="false"
            [showDelete]="false"
            [mainPhraseWords]="claimToolElement.phraseWords"
              [editable]="false"></phrase-ref>
          </div>
          </ng-container>
          -->
        <!--
      <ng-container *ngIf="claimToolElement != undefined && !claimToolElement.isPrecheck">
        <div class="l-align-spaceBetween" >
          <a (click)="addReference()" class="add-link">
            <i class="fas fa-plus"></i>
            &nbsp;
            {{ "translate.cat.addReference" | translate }}
          </a>
          <a *ngIf="displayRefOptions" (click)="displayRefOptions = false" class="t-small">
            {{ "translate.general.close" | translate }}
          </a>

        </div>
        
        <cat-doc-ref-options *ngIf="displayRefOptions" (onRefAdd)="onPhraseRefAdd($event)"
        (onRefRemove)="onPhraseRefRemove($event)"></cat-doc-ref-options>
      </ng-container>
      -->
      <ng-container *ngIf="claimToolElement.contentType == 'CLAIM' || claimToolElement.contentType == 'FOOTNOTE'">
        <div class="l-align-spaceBetween" >
          <a (click)="displayRefOptions = !displayRefOptions" class="add-link">
            <i [ngClass]="displayRefOptions ? 'fas fa-minus' : 'fas fa-plus'"></i>
            &nbsp;
            {{ "translate.claim-tool.manage.context" | translate }}
          </a>
          <!--
          <a *ngIf="displayRefOptions" (click)="displayRefOptions = false" class="t-small">
            {{ "translate.general.close" | translate }}
          </a>
          -->
        </div>
        <ng-container *ngIf="displayRefOptions">
          <p class="single-phrase-details-ref-title single-phrase-element-margin">

            {{ "translate.rev.reference" | translate }}:   
        
          </p>        
          <ng-container *ngFor="let ref of claimToolElement.references">
            <div class="single-phrase-doc-ref-container single-phrase-element-margin">
              <!-- <cat-phrase-ref class="ref" [ref]="ref" [mainPhrase]="phrase" (onDeleteRef)="onDeleteRef(ref)"
                [editable]="editable && inCatEditable" [allowEdit]="catModeSw"></cat-phrase-ref> -->
                <div class="single-phrase-ref-container single-phrase-element-margin">
                  <phrase-ref class="ref" [ref]="ref"[allowEdit]="true"
                    [showEdit]="false"
                    [disabled]="mergeOrSplitExecuted"
                    [showDelete]="false"
                    [showAddAnchors]="false"
                    [mainPhraseWords]="ref.phraseWords"
                    [editable]="true">
                  </phrase-ref>
                  <div class="l-align-spaceBetween l-mar-top">
                    <span class="footnote id"
                      >Type: {{ ref.refType }}</span
                    >
                  </div>
                </div>
                
            </div>
            </ng-container>
        </ng-container>
        <doc-ref-options [hidden]="!displayRefOptions"
        [referenceOptionsRequest]="referenceOptionsRequest"
        [disabled]="mergeOrSplitExecuted"
        ></doc-ref-options>
      </ng-container>
      <ng-container *ngIf="claimToolElement.contentType == 'CLAIM'">
        <div class="l-align-spaceBetween single-phrase-element-margin">
          <a (click)="displayAssocTextOptions = !displayAssocTextOptions" class="add-link" style="margin-top: 5px; margin-bottom: 5px;">
            <i [ngClass]="displayAssocTextOptions ? 'fas fa-minus' : 'fas fa-plus'"></i>
            &nbsp;
            {{ "translate.claim-tool.manage.content" | translate }}
          </a>
          <!--
          <a *ngIf="displayAssocTextOptions" (click)="displayAssocTextOptions = false" class="t-small">
            {{ "translate.general.close" | translate }}
          </a>
          -->
        </div>



      <ng-container *ngIf="displayAssocTextOptions">
        <p class="single-phrase-details-ref-title" *ngIf="claimToolElement.associatedText != undefined && claimToolElement.associatedText.length > 0">
          {{ "translate.general.associatedText" | translate }}:
        </p>
        <ng-container *ngFor="let assocPhrase of claimToolElement.associatedText">
          <div class="single-phrase-doc-ref-container single-phrase-element-margin">
            <!-- <cat-phrase-ref class="ref" [ref]="ref" [mainPhrase]="phrase" (onDeleteRef)="onDeleteRef(ref)"
              [editable]="editable && inCatEditable" [allowEdit]="catModeSw"></cat-phrase-ref> -->
              <div class="single-phrase-ref-container single-phrase-element-margin">
                {{ assocPhrase.assocPhraseText }}
                <div class="l-align-spaceBetween l-mar-top">
                  <span class="footnote id"
                    >{{ "translate.cat.phraseId" | translate }}: {{ assocPhrase.assocPhraseId }}</span
                  >
                </div>
              </div>
              
          </div>
        </ng-container>
      </ng-container>
      <div *ngIf="hasAssocImageOptions">
          <doc-assoc-text-options [hidden]="!displayAssocTextOptions"
          [assocPhrasesRequest]="assocPhrasesRequest"
          [disabled]="mergeOrSplitExecuted"
          ></doc-assoc-text-options>

          <div class="l-align-spaceBetween single-phrase-element-margin">
            <a (click)="displayAssocImagesOptions = !displayAssocImagesOptions" class="add-link" style="margin-top: 5px; margin-bottom: 5px;">
              <i [ngClass]="displayAssocImagesOptions ? 'fas fa-minus' : 'fas fa-plus'"></i>
              &nbsp;
              {{ "translate.claim-tool.manage.assocImages" | translate }}
            </a>
          </div>
          <doc-assoc-images-options 
            [hidden]="!displayAssocImagesOptions" 
            [assocImagesRequest]="assocImagesRequest"
            [disabled]="mergeOrSplitExecuted"
            (hasOptionsChange)="onHasAssocImageOptionsChange($event)"
          ></doc-assoc-images-options>
        </div>
      </ng-container>

      <div class="l-align-spaceBetween single-phrase-element-margin">
        <a (click)="mergeAndReorder = !mergeAndReorder" class="add-link" style="margin-top: 5px; margin-bottom: 5px;">
          <i [ngClass]="mergeAndReorder ? 'fas fa-minus' : 'fas fa-plus'"></i>
          &nbsp;
          {{ "translate.claim-tool.merge-and-reorder" | translate }}
        </a>
      </div>
        <doc-phrase-merge-and-reorder [hidden]="!mergeAndReorder"
        [docPhraseMergeAndReorderRequest]="docPhraseMergeAndReorderRequest"
        [curPhraseId]="claimToolElement.phraseId"
        [splitExecuted]="splitExecuted"
        [mergeExecuted]="mergeExecuted">
        </doc-phrase-merge-and-reorder>
        <div class="l-align-spaceBetween single-phrase-element-margin">
            <a (click)="splitPhrases = !splitPhrases" class="add-link" style="margin-top: 5px; margin-bottom: 5px;">
              <i [ngClass]="splitPhrases ? 'fas fa-minus' : 'fas fa-plus'"></i>
              &nbsp;
            {{ "translate.claim-tool.split" | translate }}
            </a>
        </div>
        <split-phrase [disabled]="mergeExecuted" [hidden]="!splitPhrases" [phraseWords]="claimToolElement.phraseWords"
        [contentType]="this.claimToolElement.contentType" [contentTypeDesc]="this.claimToolElement.contentTypeDesc"
        >
          
        </split-phrase>
    </div>
  </ng-template>

<ng-template #save>
        <div>
        <p>
          <!--Add here button-->
          <button [disabled]="isLoading || !(this.claimToolService.enableSaveChanges$ | async)" class="t-button t-button-warn" icon="pi pi-save" (click)="saveChanges()">

            {{ "translate.general.saveChanges" | translate }}
            
          </button>
          <reeval-status-icon [target]="reevalTarget" [allowRefresh]="false"></reeval-status-icon>

        </p>
      </div>
</ng-template>

<ng-template #typesTree>
  <p-tree class="fs-small" [value]="phraseTypesTree" [(selection)]="selectedPhraseType" scrollHeight="250px"
    selectionMode="single" filter="true" (onNodeSelect)="onTypeSelected($event)"
    (onNodeUnselect)="nodeUnselect($event)"></p-tree>
</ng-template>